let url = 'https://api.aiotlims.com/'


export default {
  url
}